import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IMobileNumber } from '@shared/models/numbers';
import { MobileNumberPipe } from '@shared/pipes/mobile-number.pipe';

@Component({
	selector: 'app-link-phone-number',
	imports: [CommonModule, MobileNumberPipe],
	templateUrl: './link-phone-number.component.html',
	styleUrl: './link-phone-number.component.scss',
})
export class LinkPhoneNumberComponent {
	@Input() phoneNumber: IMobileNumber | null;

	get query(): string {
		return `tel:${this.phoneNumber?.e164Number}`;
	}
}
